import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { OpenTalkApi } from 'api';

function useGet(id: string) {
  return useAuthQuery(
    getQueryKeys([KEY]).detail(id),
    () => OpenTalkApi.get(id),
    {
      enabled: !!id,
      select: (data) => data.data,
    },
  );
}

export default useGet;
